<template>
	<v-col class="ma-0 pa-5" cols="12">

		<!-- ======================= STEP: 뷰어 (분할화면 스트리밍) ======================= -->
		<template v-if="step === 'viewer'">
			<v-row class="ma-0 pa-0 mb-3" justify="space-between">
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0" align="center">
						{{ tsg('selectSplitScreen') }} :
						<v-menu offset-y :close-on-content-click="false" v-model="splitScreenSelectMenu">
							<template v-slot:activator="{ on, attrs }">
								<v-btn id="split_screen_select_menu" class="ml-2 text-none" v-bind="attrs" v-on="on">
									<v-row class="ma-0 pa-0" justify="space-between">
										<v-col class="ma-0 pa-0 pl-2 ellipsis" cols="11" id="select_menu_text">
											{{ selectedSplitScreen }}
										</v-col>
										<v-col class="ma-0 pa-0" cols="1" align-self="end">
											<v-img src="@/assets/images/icon_arrow_down_small.png"></v-img>
										</v-col>
									</v-row>
								</v-btn>
							</template>
							<v-list>
								<v-list-item id="select_list_item" v-for="(item, index) in splitScreenList" :key="index"
									@click="closeNameChangeDialog(item.splitName)">
									<v-row class="ma-0 pa-0" justify="space-between">
										<v-col class="ma-0 pa-0 pl-2" cols="8" align-self="center">
											<v-row class="ma-0 pa-0" justify="space-between">
												<v-col class="ma-0 pa-0 pr-1" cols="2" align-self="center">
													<v-img v-if="item.splitName == selectedSplitScreen" src="@/assets/images/icon_check.png"></v-img>
												</v-col>
												<v-col class="ma-0 pa-0 ellipsis" cols="10" style="text-align: left;max-width:200px;">
													{{ item.splitName }}
												</v-col>
											</v-row>
										</v-col>
										<v-col class="ma-0 pa-0" cols="4">
											<v-btn id="transparent_btn_select_small" elevation="0"
												@click="nameChangeDialogFunc(item.id, item.splitName)">
												<v-img src="@/assets/images/icon_pen.png"></v-img>
											</v-btn>
											<v-btn id="transparent_btn_select_small" elevation="0" @click="deleteSplit(item.id)">
												<v-img src="@/assets/images/close.png"></v-img>
											</v-btn>
										</v-col>
									</v-row>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-btn id="blue_btn" class="ml-2" @click="goCreateSplitScreen">
							{{ tsg('createSplitScreen') }}
						</v-btn>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0">
						<v-btn id="transparent_btn" elevation="0" @click="splitScreenDialogVisible = true">
							<v-img src="@/assets/images/icon_split_screen.png"></v-img>
						</v-btn>
						<v-btn id="transparent_btn" elevation="0" @click="handleFullScreen">
							<v-img src="@/assets/images/video_fullscreen.png"></v-img>
						</v-btn>
					</v-row>
				</v-col>
			</v-row>

			<v-row id="cameras-area" class="ma-0 pa-0" v-if="!loading">
				<!-- 4분할 -->
				<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 4" :key="view4">
					<v-row class="ma-0 pa-2 full-height" justify="center">
						<v-col v-for="(item, index) in 2" :key="index" class="ma-0 pa-0" cols="auto">
							<v-col v-for="(item_nest, index_nest) in 2" :key="index_nest" class="ma-0 pa-0" cols="12">
								<v-hover v-slot="{ hover }">
									<v-col v-if="checkSplitScreenCameraList(index, index_nest, 2)" id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 2 * index, 4)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
											{{ getSplitName(index, index_nest, 2) }}
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" video group :index="index" :indexCalc="2"
											:index_nest="index_nest" :players="players" :splitScreenCameraList="splitScreenCameraList"
											:viewCount="viewCount" :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-4-progress' + (index_nest + 2 * index)" indeterminate color="blue" />
										<video :id="'example-4-video' + (index_nest + 2 * index)" width=550 height=350 muted
											style="object-fit: fill;" class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
									</v-col>
									<v-col v-else id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 2 * index, 4)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="2" :index_nest="index_nest"
											:players="players" :splitScreenCameraList="splitScreenCameraList" :viewCount="viewCount"
											:selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-4-progress' + (index_nest + 2 * index)" indeterminate color="blue" />
										<video :id="'example-4-video' + (index_nest + 2 * index)" width=550 height=350 muted
											style="object-fit: fill;" class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
										<v-col :id="'no-data-video' + (index_nest + 2 * index)" class="video_grey_box" style="display:flex;">
											{{ t('noData') }}
										</v-col>
									</v-col>
								</v-hover>
							</v-col>
						</v-col>
					</v-row>
				</v-col>

				<!-- 9분할 -->
				<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 9" :key="view9">
					<v-row class="ma-0 pa-2 full-height" align="center">
						<v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0" cols="4">
							<v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
								<v-hover v-slot="{ hover }">
									<v-col v-if="checkSplitScreenCameraList(index, index_nest, 3)" id="camera_9box" class="ma-0 pa-0">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 3 * index, 9)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
											{{ getSplitName(index, index_nest, 3) }}
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" video group :index="index" :indexCalc="3"
											:index_nest="index_nest" :players="players" :splitScreenCameraList="splitScreenCameraList"
											:viewCount="viewCount" :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-9-progress' + (index_nest + 3 * index)" indeterminate color="blue" />
										<video :id="'example-9-video' + (index_nest + 3 * index)" width=550 height=350 muted
											style="object-fit: fill;" class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
									</v-col>
									<v-col v-else id="camera_9box" class="ma-0 pa-0">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 3 * index, 9)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="3" :index_nest="index_nest"
											:players="players" :splitScreenCameraList="splitScreenCameraList" :viewCount="viewCount"
											:selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-9-progress' + (index_nest + 3 * index)" indeterminate color="blue" />
										<video :id="'example-9-video' + (index_nest + 3 * index)" muted style="object-fit: fill;"
											class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
										<v-col :id="'no-data-video' + (index_nest + 3 * index)" class="video_grey_box" style="display:flex;">
											{{ t('noData') }}
										</v-col>
									</v-col>
								</v-hover>
							</v-col>
						</v-col>
					</v-row>
				</v-col>

				<!-- 16분할 -->
				<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 16" :key="view16">
					<v-row class="ma-0 pa-2 full-height" align="center">
						<v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0" cols="3">
							<v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
								<v-hover v-slot="{ hover }">
									<v-col v-if="checkSplitScreenCameraList(index, index_nest, 4)" id="camera_16box" class="ma-0 pa-0">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 4 * index, 16)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
											{{ getSplitName(index, index_nest, 4) }}
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" video group :index="index" :indexCalc="4"
											:index_nest="index_nest" :players="players" :splitScreenCameraList="splitScreenCameraList"
											:viewCount="viewCount" :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-16-progress' + (index_nest + 4 * index)" indeterminate color="blue" />
										<video :id="'example-16-video' + (index_nest + 4 * index)" width=550 height=350 muted
											style="object-fit: fill;" class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
									</v-col>
									<v-col v-else id="camera_16box" class="ma-0 pa-0">
										<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
											<v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 4 * index, 16)">
												<v-img src="@/assets/images/dots.png"></v-img>
											</v-btn>
										</v-col>
										<SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="4" :index_nest="index_nest"
											:players="players" :splitScreenCameraList="splitScreenCameraList" :viewCount="viewCount"
											:selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
											@deleteCamera="deleteSplitCamera" @openCameraSearchDialog="openCameraSearchDialogFunc" />
										<v-progress-linear :id="'example-16-progress' + (index_nest + 4 * index)" indeterminate color="blue" />
										<video :id="'example-16-video' + (index_nest + 4 * index)" muted style="object-fit: fill;"
											class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
										</video>
										<v-col :id="'no-data-video' + (index_nest + 4 * index)" class="video_grey_box" style="display:flex;">
											{{ t('noData') }}
										</v-col>
									</v-col>
								</v-hover>
							</v-col>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row class="ma-0 pa-0" v-else>
				<v-col class="ma-0 pa-10 mt-10" cols="12" align="center">
					<v-progress-circular indeterminate color="white" :width="6" :size="50"></v-progress-circular>
				</v-col>
			</v-row>
		</template>

		<!-- ======================= STEP: 레이아웃(분할 수) 선택 ======================= -->
		<template v-else-if="step === 'select'">
			<v-col class="ma-0 pa-0" cols="12" align="center">
			<v-col class="ma-0 pa-0 mt-10" cols="12" id="group_box">
				<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
					{{ tsg('selectSplitScreenLayout') }}
					<v-col v-if="splitScreenList.length > 0" id="close_btn" class="ma-0 pa-0" cols="auto">
						<v-btn width="2rem" height="2rem" class="ma-0 pa-0 back_clean_btn" elevation="0" @click="backToViewer">
							<img src="@/assets/images/popup_close.png" id="btn_img">
						</v-btn>
					</v-col>
				</v-col>
				<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12">
					<v-row class="ma-0 pa-0 pt-9 pb-9" align="center">
						<v-col class="ma-0 pa-0" cols="4">
							<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4" src="@/assets/images/4view.png"></v-img>
							<v-btn width="8rem" height="2rem" class="ma-0 pa-0 pl-2 pr-2" id="blue_btn" elevation="0" @click="chooseLayout(4)">
								{{ '4' + tsg('createdLayoutWithCameras') }}
							</v-btn>
						</v-col>
						<v-col class="ma-0 pa-0" cols="4">
							<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4" src="@/assets/images/9view.png"></v-img>
							<v-btn width="8rem" height="2rem" class="ma-0 pa-0 pl-2 pr-2" id="blue_btn" elevation="0" @click="chooseLayout(9)">
								{{ '9' + tsg('createdLayoutWithCameras') }}
							</v-btn>
						</v-col>
						<v-col class="ma-0 pa-0" cols="4">
							<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4" src="@/assets/images/16view.png"></v-img>
							<v-btn width="8rem" height="2rem" class="ma-0 pa-0 pl-2 pr-2" id="blue_btn" elevation="0" @click="chooseLayout(16)">
								{{ '16' + tsg('createdLayoutWithCameras') }}
							</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-col>
			</v-col>
		</template>

		<!-- ======================= STEP: 슬롯 카메라 선택 ======================= -->
		<template v-else-if="step === 'cameraSelect'">
			<!-- 4분할 -->
			<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 4">
				<v-row class="ma-0 pa-2" align="center">
					<v-col class="ma-0 pa-0 pr-2" cols="6" align="right">
						<v-col v-for="(item, index) in 2" :key="index" class="slot_box split_4box ma-0 pa-0 mb-4" cols="12"
							@click="cameraSelect(index)">
							<template v-if="slotCameras[index]">
								<v-img v-if="slotCameras[index].thumbnailSrc" :src="slotCameras[index].thumbnailSrc" height="100%" class="slot_img"></v-img>
								<div class="slot_name ellipsis">{{ slotCameras[index].cameraName }}</div>
							</template>
							<v-btn v-else width="9rem" height="2rem" class="ma-0 pa-0" id="blue_btn" elevation="0">{{ tsg('selectCamera') }}</v-btn>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-0 pl-2" cols="6" align="left">
						<v-col v-for="(item, index) in 2" :key="index" class="slot_box split_4box ma-0 pa-0 mb-4" cols="12"
							@click="cameraSelect(index + 2)">
							<template v-if="slotCameras[index + 2]">
								<v-img v-if="slotCameras[index + 2].thumbnailSrc" :src="slotCameras[index + 2].thumbnailSrc" height="100%" class="slot_img"></v-img>
								<div class="slot_name ellipsis">{{ slotCameras[index + 2].cameraName }}</div>
							</template>
							<v-btn v-else width="9rem" height="2rem" class="ma-0 pa-0" id="blue_btn" elevation="0">{{ tsg('selectCamera') }}</v-btn>
						</v-col>
					</v-col>
				</v-row>
			</v-col>
			<!-- 9분할 -->
			<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 9">
				<v-row class="ma-0 pa-0 pl-1 pr-1" align="center">
					<v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0 pr-1 pl-1" cols="4">
						<v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" class="slot_box split_9box ma-0 pa-0 mb-2" cols="12"
							@click="cameraSelect(index_nest + 3 * index)">
							<template v-if="slotCameras[index_nest + 3 * index]">
								<v-img v-if="slotCameras[index_nest + 3 * index].thumbnailSrc" :src="slotCameras[index_nest + 3 * index].thumbnailSrc" height="100%" class="slot_img"></v-img>
								<div class="slot_name ellipsis">{{ slotCameras[index_nest + 3 * index].cameraName }}</div>
							</template>
							<v-btn v-else width="9rem" height="2rem" class="ma-0 pa-0" id="blue_btn" elevation="0">{{ tsg('selectCamera') }}</v-btn>
						</v-col>
					</v-col>
				</v-row>
			</v-col>
			<!-- 16분할 -->
			<v-col class="ma-0 pa-0" cols="12" v-if="viewCount == 16">
				<v-row class="ma-0 pa-2" align="center">
					<v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0 pl-1 pr-1" cols="3">
						<v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" class="slot_box split_16box ma-0 pa-0 mb-2" cols="12"
							@click="cameraSelect(index_nest + 4 * index)">
							<template v-if="slotCameras[index_nest + 4 * index]">
								<v-img v-if="slotCameras[index_nest + 4 * index].thumbnailSrc" :src="slotCameras[index_nest + 4 * index].thumbnailSrc" height="100%" class="slot_img"></v-img>
								<div class="slot_name ellipsis">{{ slotCameras[index_nest + 4 * index].cameraName }}</div>
							</template>
							<v-btn v-else width="8rem" height="2rem" class="ma-0 pa-0" id="blue_btn" elevation="0">{{ tsg('selectCamera') }}</v-btn>
						</v-col>
					</v-col>
				</v-row>
			</v-col>

			<v-col class="ma-0 pa-0 mt-3 mb-7" cols="12">
				<v-row class="ma-0 pa-0" align="center" justify="center">
					<v-btn width="9rem" height="2rem" class="ma-0 pa-0" id="grey_btn" elevation="0" @click="backToSelect">{{ t('cancel') }}</v-btn>
					<v-btn width="9rem" height="2rem" class="ma-0 pa-0 ml-3" id="blue_btn" elevation="0" :loading="createLoading"
						@click="createSplit">{{ t('create') }}</v-btn>
				</v-row>
			</v-col>
		</template>

		<!-- 카메라 선택 픽커 (카메라그룹 내 카메라) -->
		<CameraGroupSplitCameraDialog :dialogVisible="cameraSearchDialogVisible" :cameras="groupCameras"
			@visible="cameraSearchDialogVisibleFunc" @selectedCamera="onPickerSelect" />
		<NameChangeDialog :dialogVisible="nameChangeDialogVisible" :editType="editNameType" :currentId="currentId"
			:currentName="currentName" @nameUpdate="nameUpdateFunc" @visible="nameChangeDialogVisibleFunc" />
		<SplitScreenDialog :dialogVisible="splitScreenDialogVisible" :viewCount="viewCount"
			@visible="splitScreenDialogVisibleFunc" @selectedViewCount="selectedViewCountFunc" />
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import splitScreenMixin from '@/views/store-group/mixin/splitScreen';
import peerMixin from '@/views/player/mixin/peer';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import ja from 'video.js/dist/lang/ja.json';
import CameraGroupSplitCameraDialog from '@/components/dialogs/CameraGroupSplitCameraDialog.vue';
import NameChangeDialog from '@/components/dialogs/NameChangeDialog.vue';
import SplitScreenDialog from '@/components/dialogs/SplitScreenDialog.vue';
import SplitScreenHoverMenuList from '@/components/SplitScreenHoverMenuList.vue';
import { isIOS, isSafari } from 'mobile-device-detect';
import rtcViewer from '@/api/webrtc';
import Offline from '@/api/offline';
import { ApiVersion } from '@/constants';

export default {
	components: {
		CameraGroupSplitCameraDialog, NameChangeDialog, SplitScreenDialog, SplitScreenHoverMenuList
	},
	// 스트리밍 로직(getSplitListCameras/getRTCPeerConStream/getAllStreamingUrl/deleteSplit/deleteSplitCamera 등)은
	// 점포그룹 splitScreen 믹스인을 그대로 재사용하고, 그룹 전용 메서드(getSplitList/goCreateSplitScreen)만 오버라이드한다.
	mixins: [mixin.common, splitScreenMixin, peerMixin],
	data: () => ({
		currentGroupId: '',        // = 카메라그룹 id (splitScreen 믹스인이 참조)
		step: 'viewer',            // 'viewer' | 'select' | 'cameraSelect'
		// --- 뷰어(스트리밍) 상태 ---
		viewCount: 4,
		cameraSearchDialogVisible: false,
		nameChangeDialogVisible: false,
		splitScreenDialogVisible: false,
		splitScreenSelectMenu: false,
		splitScreenList: [],
		selectedSplitScreen: '',
		splitScreenCameraList: [],
		streamingCount: 0,
		players: [],
		currentItemIndex: 0,
		splitGroupId: '',
		editNameType: 'splitlist',
		currentName: '',
		currentId: '',
		view4: 0,
		view9: 10,
		view16: 100,
		playerOptions: { language: 'ja', languages: { ja }, autoplay: 'muted' },
		loading: false,
		pausePlayInterval: null,
		webrtcConnections: [],
		// --- 카메라 선택(픽커/슬롯) 상태 ---
		groupCameras: [],          // 카메라그룹 내 카메라 (슬롯 배치/변경 풀)
		slotCameras: [],           // 슬롯 index → 배치된 카메라(전체 객체) — 생성 단계 미리보기용
		selectedSlotIndex: null,   // 픽커로 배치 중인 슬롯 index
		selectedCameraList: [],    // 등록 payload용 [{index, contractCd, portNo, thingType}]
		pickerMode: 'slot',        // 'slot'(생성 슬롯 배치) | 'upsert'(뷰어 카메라 변경)
		createLoading: false,
		listCount: 1,
	}),
	watch: {
		selectedSplitScreen: function (item) {
			this.$store.commit('setSelectedSplitScreen', item);
			this.getSplitListCameras(0);
		}
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
	},
	async mounted() {
		this.fetchGroupCameras();
		await this.getSplitList();
		if (isSafari) {
			this.initializePausePlayInterval();
		}
		window.addEventListener('beforeunload', () => {
			this.closeAndDisposeAll();
		});
	},
	beforeDestroy() {
		this.closeAndDisposeAll();
	},
	methods: {
		tsg(t) {
			return this.$t("lang.group." + t);
		},
		// [오버라이드] 카메라그룹 분할화면 리스트 조회 (믹스인은 점포그룹-id 엔드포인트라 오버라이드)
		async getSplitList() {
			this.loading = true;
			let params = {};
			await this.networkController.getCameraGroupSplitList(params, this.currentGroupId)
				.then(async (res) => {
					this.splitScreenList = res.data;
					this.$store.commit('setAllSplitScreenList', res.data);
					if (this.splitScreenList.length === 0) {
						this.goCreateSplitScreen();
					} else {
						if (this.$store.state.userData.selectedSplitScreen) {
							this.selectedSplitScreen = this.$store.state.userData.selectedSplitScreen;
						} else {
							this.selectedSplitScreen = this.splitScreenList[0].splitName;
						}
						this.loading = false;
					}
				}).catch(() => { this.loading = false; });
		},
		// [오버라이드] 분할화면 생성 진입 → 레이아웃 선택 스텝 (믹스인/점포그룹은 라우팅)
		goCreateSplitScreen() {
			this.computeListCount();
			this.step = 'select';
			this.loading = false;
		},
		// 슬롯에 배치 가능한 카메라 풀 = 카메라그룹 내 카메라
		fetchGroupCameras() {
			if (!this.currentGroupId) return;
			this.networkController.getCameraCheckListGroup({}, this.currentGroupId)
				.then((res) => { this.groupCameras = res.data.cameras || []; })
				.catch(() => { });
		},
		computeListCount() {
			let maxIndex = 0;
			this.splitScreenList.forEach((item) => {
				if (item.splitName && item.splitName.includes('名称未設定')) {
					let tempIndex = item.splitName.split('名称未設定')[1] * 1;
					if (tempIndex >= maxIndex) maxIndex = tempIndex;
				}
			});
			this.listCount = maxIndex + 1;
		},
		backToViewer() {
			this.step = 'viewer';
		},
		backToSelect() {
			this.step = 'select';
		},
		chooseLayout(count) {
			this.viewCount = count;
			this.slotCameras = new Array(count).fill(null);
			this.selectedCameraList = [];
			this.step = 'cameraSelect';
		},
		// 슬롯 클릭 → 카메라 픽커 (생성 단계)
		cameraSelect(index) {
			this.pickerMode = 'slot';
			this.selectedSlotIndex = index;
			this.cameraSearchDialogVisible = true;
		},
		// 픽커에서 카메라 선택 시: 생성 슬롯 배치 or 뷰어 카메라 변경
		onPickerSelect(item) {
			if (item == null) return;
			if (this.pickerMode === 'slot') {
				this.$set(this.slotCameras, this.selectedSlotIndex, item);
				this.rebuildSelectedCameraList();
			} else {
				this.modifySelectedCameraFunc(item);
			}
		},
		rebuildSelectedCameraList() {
			const list = [];
			this.slotCameras.forEach((cam, idx) => {
				if (cam) list.push({ index: idx, contractCd: cam.contractCd, portNo: cam.portNo, thingType: cam.thingType });
			});
			this.selectedCameraList = list;
		},
		// 분할화면 생성 (cameraGroupId 사용, 그 외 body는 기존 addCameraSplit 과 동일)
		async createSplit() {
			this.createLoading = true;
			const splitName = '名称未設定' + this.listCount;
			const params = {
				cameraGroupId: this.currentGroupId,
				splitName,
				cameras: this.selectedCameraList,
				viewCount: this.viewCount,
			};
			await this.networkController.addCameraSplit(params)
				.then(async () => {
					this.createLoading = false;
					this.$store.commit('setSelectedSplitScreen', splitName);
					this.step = 'viewer';
					this.$nextTick(async () => { await this.getSplitList(); });
				}).catch(() => { this.createLoading = false; });
		},
		// 뷰어에서 카메라 변경 (hover 메뉴) → upsert
		async modifySelectedCameraFunc(selectedCamera) {
			if (selectedCamera != null) {
				this.closeAndDisposeAll();
				this.$vloading.show();
				const addParams = {
					index: this.currentItemIndex,
					contractCd: selectedCamera.contractCd,
					portNo: selectedCamera.portNo,
					thingType: selectedCamera.thingType
				};
				await this.networkController.upsertCameraSplitCamera(addParams, this.splitGroupId)
					.then(() => { this.$vloading.hide(); this.getSplitListCameras(0); })
					.catch(() => { this.$vloading.hide(); });
			}
		},
		openCameraSearchDialogFunc(index) {
			this.pickerMode = 'upsert';
			this.currentItemIndex = index;
			this.cameraSearchDialogVisible = true;
		},
		cameraSearchDialogVisibleFunc(visible) {
			this.cameraSearchDialogVisible = visible;
			if (visible == false) this.showMenu(null, this.viewCount);
		},
		nameChangeDialogVisibleFunc(visible) {
			this.nameChangeDialogVisible = visible;
		},
		closeNameChangeDialog(value) {
			if (this.nameChangeDialogVisible != true) this.splitScreenSelectMenu = false;
			this.selectedSplitScreen = value;
		},
		nameUpdateFunc(item) {
			let currentIndex = this.splitScreenList.findIndex(r => r.id === item.id);
			this.splitScreenList[currentIndex].splitName = item.splitName;
			this.selectedSplitScreen = item.splitName;
		},
		nameChangeDialogFunc(id, name) {
			this.editNameType = 'splitlist';
			this.currentId = id;
			this.currentName = name;
			this.nameChangeDialogVisible = true;
			this.splitScreenSelectMenu = true;
			event.stopPropagation();
		},
		selectedViewCountFunc(value) {
			if (value != this.viewCount) {
				try {
					for (let i = 0; i < this.players.length; i++) {
						if (this.players[i]) this.players[i].dispose();
					}
					this.players = [];
				} catch (e) { console.log(e); }
				this.viewCount = value;
				const idx = this.splitScreenList.findIndex(r => r.splitName === this.selectedSplitScreen);
				this.networkController.updateCameraSplit({
					viewCount: value,
					splitName: this.selectedSplitScreen
				}, this.splitScreenList[idx].id)
					.then(async () => {
						if (value == 9) this.view9 += 1;
						else if (value == 16) this.view16 += 1;
						else this.view4 += 1;
						this.getSplitListCameras(value);
					}).catch(() => { });
			}
		},
		splitScreenDialogVisibleFunc(visible) {
			this.splitScreenDialogVisible = visible;
		},
		stopProgressBar(id) {
			const progress = document.getElementById(id);
			if (progress) progress.style.display = 'none';
		},
		async createRTCPlayer(player, webrtcInforms, streamingCount, cameraInfo) {
			this.webrtcConnections.push(webrtcInforms);
			await rtcViewer.startViewer(player, webrtcInforms);
			if (cameraInfo.apiVersion > ApiVersion.NO_DATA_CH) {
				const that = this.getOfflineThat(webrtcInforms, cameraInfo);
				const offline = new Offline(that, rtcViewer);
				offline.viewer.dataChannel.onopen = () => { offline.sendMessage('live'); };
				offline.viewer.dataChannel.onmessage = (evt) => { offline.receiveMessageSimple(evt); };
			}
			if (cameraInfo.webrtc.playback && cameraInfo.webrtc.playback.supported) {
				const that = this.getOfflineThat(webrtcInforms, cameraInfo);
				const offline = new Offline(that, rtcViewer);
				offline.viewer.dataChannel.onopen = () => { offline.sendMessage('live'); };
				offline.viewer.dataChannel.onmessage = (evt) => { offline.receiveMessageSimple(evt); };
			}
			this.players[streamingCount] = videojs(player.id, this.playerOptions, () => {
				let duration = 1000;
				if (isIOS) duration = 2000;
				setTimeout(() => {
					this.stopProgressBar(`example-${this.viewCount}-progress${streamingCount}`);
					this.players[streamingCount].el_.querySelector('video').src = null;
					this.players[streamingCount].el_.querySelector('video').srcObject = player.srcObject;
					this.players[streamingCount].play();
				}, duration);
			});
			this.streamingCount = this.streamingCount + 1;
		},
		createPlayer(videoSourceUrl, streamingCount) {
			const vm = this;
			this.players[streamingCount] = videojs(`example-${this.viewCount}-video${streamingCount}`, this.playerOptions, function onPlayerReady() {
				this.src({ src: videoSourceUrl, type: 'application/x-mpegURL' });
				setTimeout(() => {
					vm.stopProgressBar(`example-${vm.viewCount}-progress${streamingCount}`);
					this.play();
				}, 500);
				this.on('error', function (event) { console.log(event); });
				this.on('waiting', () => {
					setTimeout(() => {
						if (this.readyState() < 3) { vm.restartPlayer(streamingCount); }
					}, 20000);
				});
			});
			this.streamingCount = this.streamingCount + 1;
		},
		closeAndDisposeAll() {
			try {
				for (let i = 0; i < this.players.length; i++) {
					if (this.players[i]) this.players[i].dispose();
				}
				if (this.pausePlayInterval) { clearInterval(this.pausePlayInterval); }
			} catch (e) { console.log(e); }
			this.webrtcConnections.forEach(informs => { rtcViewer.stopViewer(informs); });
			this.webrtcConnections = [];
		},
		changeCameraBoxStyle(isAdd) {
			const cameras = document.querySelectorAll(`#cameras-area #camera_${this.viewCount}box`);
			const className = `camera_full_${this.viewCount}box`;
			cameras.forEach(ele => isAdd ? ele.classList.add(className) : ele.classList.remove(className));
			if (this.viewCount === 4) {
				const videos = document.querySelectorAll(`#cameras-area #camera_${this.viewCount}box video`);
				const style = `video-js-${this.viewCount}`;
				videos.forEach(ele => isAdd ? ele.classList.add(style) : ele.classList.remove(style));
			}
			if (isAdd) {
				document.addEventListener('fullscreenchange', this.exitFullScreen);
				document.addEventListener('mozfullscreenchange', this.exitFullScreen);
				document.addEventListener('webkitfullscreenchange', this.exitFullScreen);
				document.addEventListener('MSFullscreenChange', this.exitFullScreen);
			} else {
				document.removeEventListener('fullscreenchange', this.exitFullScreen);
				document.removeEventListener('moxfullscreenchange', this.exitFullScreen);
				document.removeEventListener('webkitfullscreenchange', this.exitFullScreen);
				document.removeEventListener('MSFullscreenChange', this.exitFullScreen);
			}
		},
		exitFullScreen() {
			if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
				this.changeCameraBoxStyle(false);
			}
		},
		handleFullScreen() {
			const elem = document.getElementById('cameras-area');
			this.changeCameraBoxStyle(true);
			if (elem.requestFullscreen) { elem.requestFullscreen(); }
			else if (elem.mozRequestFullScreen) { elem.mozRequestFullScreen(); }
			else if (elem.webkitRequestFullscreen) { elem.webkitRequestFullscreen(); }
			else if (elem.msRequestFullscreen) { elem.msRequestFullscreen(); }
		},
	}
}
</script>

<style lang="scss" scoped>
/* ===== 레이아웃 선택 박스 ===== */
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
	position: relative;
}
#close_btn {
	position: absolute;
	top: 5px;
	right: 15px;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
}
/* ===== 슬롯(카메라 미배치/배치) 박스 ===== */
.slot_box {
	background-color: #000000;
	border: 1px solid #4A4A4A;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	overflow: hidden;
}
.split_4box { height: 13rem; }
.split_9box { height: 9rem; }
.split_16box { height: 7rem; }
.slot_img { width: 100%; height: 100%; }
.slot_name {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 2px 8px;
	background-color: rgba(0, 0, 0, 0.7);
	color: #A8A8A8;
	font-size: 0.8rem;
	text-align: left;
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
/* ===== 뷰어(스트리밍) 박스 — store-group Index.vue 와 동일 ===== */
.camera_full_4box { height: 49vh !important; min-height: 49vh !important; min-width: 49vw !important; }
.camera_full_9box { height: 33vh !important; min-height: 33vh !important; }
.camera_full_16box { height: 24vh !important; min-height: 24vh !important; }
#camera_4box {
	background-color: #4E4E4E;
	width: 98%;
	height: 15rem;
	min-height: 15rem;
	position: relative;
}
#camera_9box {
	background-color: #4E4E4E;
	width: 100%;
	height: 12rem;
	min-height: 12rem;
	position: relative;
}
#camera_16box {
	background-color: #4E4E4E;
	width: 100%;
	height: 10rem;
	min-height: 10rem;
	position: relative;
}
#camera_select_btn {
	position: absolute;
	top: 4%;
	right: 2%;
	z-index: 3;
}
#transparent_btn {
	background-color: transparent;
	max-width: 4em;
	min-width: 4em;
}
#transparent_btn_select_small {
	background-color: transparent;
	max-width: 3em;
	min-width: 3em;
}
#camera_select_bottom_bar {
	position: absolute;
	bottom: 0%;
	text-align: left;
	padding-left: 1em !important;
	font-size: 0.8em;
	z-index: 3;
	background-color: rgba(0, 0, 0, 0.7);
	color: #A8A8A8;
}
.v-list {
	background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
	.v-list-item { min-height: 0px; color: white !important; }
	.v-list-item__content { color: white; padding: 5px 0; }
}
#split_screen_select_menu {
	background-color: transparent;
	border: 1px solid #4A4A4A;
	color: white;
	height: 2.7em;
	width: 20em;
	justify-content: start;
}
#select_list_item { padding: 0px !important; }
#select_menu_text { text-align: start; max-width: 185px; }
#hover_btn {
	background-color: rgba(0, 0, 0, 0.7);
	color: white;
	min-width: 3em;
	max-width: 3em;
}
.video-js {
	width: 100%;
	height: 15rem;
	min-width: 30rem;
	min-height: 15rem;
	top: 0px;
	left: 0px;
	padding: 0px;
	margin: 0px !important;
}
.video-js-9 {
	width: 100%;
	height: 100%;
	min-width: 0;
	min-height: 0;
}
.video-js-4 { min-height: 49vh; }
.video_grey_box {
	z-index: 1;
	position: absolute;
	justify-content: center;
	align-items: center;
	display: none;
	background: grey;
	height: 100%;
	top: 0px;
}
#middle_divider { background-color: #4C4C4C; }
</style>
